export default "__VITE_ASSET__v5cMo54j__"